<template>
    <div class="view--process">
        Hello
        <process-timer label="Process 1" :time="120"></process-timer>
    </div>
</template>

<script>
import ProcessTimer from '../components/ProcessTimer.vue';

export default {
  name: 'process',
  components: {
    ProcessTimer,
  },
};
</script>
